import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "mx-auto max-w-2xl lg:max-w-7xl" }
const _hoisted_3 = ["innerHTML"]

import type { MarkdownElementProps } from "./MarkdownElementProps";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed } from "vue";
import HorizontalSpacing from "@/views/blocks/shared/section/layout/spacing/HorizontalSpacing.vue";
import markdownit from "markdown-it";
import { handleDelegatedHashNavigation } from "@/shared/utils/router/hashNavigation";
import ScrollAnimation from "@/views/blocks/shared/section/animations/ScrollAnimation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MarkdownElement',
  props: {
    block: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const md = new markdownit();

const renderedMarkdown = computed(() => {
    return md.render(dataValues.value.markdown.data.text || "");
});

const proseStyle = computed(() => {
    const textColor = styleValues.value.text;
    const subtleColor = `color-mix(in srgb, ${textColor}, transparent 90%)`;
    const markerColor = `color-mix(in srgb, ${textColor}, transparent 60%)`;

    return {
        color: textColor,
        "--tw-prose-body": textColor,
        "--tw-prose-headings": textColor,
        "--tw-prose-lead": textColor,
        "--tw-prose-bold": textColor,
        "--tw-prose-captions": textColor,
        "--tw-prose-quotes": textColor,
        "--tw-prose-code": textColor,
        "--tw-prose-links": textColor,
        "--tw-prose-hr": subtleColor,
        "--tw-prose-quote-borders": subtleColor,
        "--tw-prose-th-borders": subtleColor,
        "--tw-prose-td-borders": subtleColor,
        "--tw-prose-bullets": markerColor,
        "--tw-prose-counters": markerColor,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScrollAnimation, { type: _ctx.scrollAnimationType }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: _ctx.block.webId,
        style: _normalizeStyle({
                backgroundColor: styleValues.value.background,
            })
      }, [
        _createVNode(HorizontalSpacing, {
          class: _normalizeClass([
                    dataValues.value.formatting.data.paddingTop,
                    dataValues.value.formatting.data.paddingBottom,
                ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.markdown.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "markdown"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("article", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleDelegatedHashNavigation) && _unref(handleDelegatedHashNavigation)(...args))),
                        innerHTML: renderedMarkdown.value,
                        class: _normalizeClass([
                                'prose prose-img:rounded-lg',
                                dataValues.value.formatting.data.elementAlign,
                                dataValues.value.formatting.data.maxWidth,
                                dataValues.value.formatting.data.textAlign,
                                dataValues.value.formatting.data.textSize,
                            ]),
                        style: _normalizeStyle(proseStyle.value)
                      }, null, 14, _hoisted_3)
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ], 12, _hoisted_1)
    ]),
    _: 1
  }, 8, ["type"]))
}
}

})